import { render, staticRenderFns } from "./news_sheng.vue?vue&type=template&id=1b7778aa&scoped=true&"
import script from "./news_sheng.vue?vue&type=script&lang=js&"
export * from "./news_sheng.vue?vue&type=script&lang=js&"
import style0 from "./news_sheng.vue?vue&type=style&index=0&id=1b7778aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7778aa",
  null
  
)

export default component.exports